//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { createViewabilityTracker } from '~/utils/bannerViewability'

export default {
  name: 'PeekCarousel',
  props: {
    items: {
      type: Array,
      required: true,
    },
    activeWidth: {
      type: Number,
      default: 432,
    },
    activeHeight: {
      type: Number,
      default: 243,
    },
    sideWidth: {
      type: Number,
      default: 329,
    },
    sideHeight: {
      type: Number,
      default: 185,
    },
    gap: {
      type: Number,
      default: 16,
    },
    interval: {
      type: Number,
      default: 7000,
    },
    autoplay: {
      type: Boolean,
      default: true,
    },
    // GA4計測用。'yasai' / 'gohan' など。未指定の場合は計測しない
    bannerType: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      activeIndex: 0,
      // 前後に2枚ずつクローンを足しているため、trackIndexはactiveIndexより2大きい
      // (1枚だけだと、クローン位置で停止する間だけそのさらに隣が存在せず一瞬空白になるため)
      trackIndex: 2,
      disableTransition: false,
      transitionDuration: 400, // CSSのtransition: transform 0.4s easeと合わせる
      timer: null,
      snapTimer: null,
      // ホバー中にクリック操作でstartAutoplayが呼ばれても再開しないようにするフラグ
      isHovering: false,
      // カルーセルの面積の50%以上が画面内にあるか（中央バナーが見えているかの判定に使う）
      isInView: false,
      isPageVisible: true,
      // 実データ（items）のindexごとの画像の読み込み状態。Vue 2は後から追加したキーの変更を
      // 検知しないため、全キーをここで作っておく
      imageStatus: this.items.reduce((status, _, index) => {
        status[index] = 'loading'
        return status
      }, {}),
    }
  },
  computed: {
    // 先頭に末尾2枚の複製、末尾に先頭2枚の複製を足して、端でも隣が見えるようにする
    extendedItems() {
      const length = this.items.length

      if (length === 0) {
        return []
      }

      return [
        this.items[(length - 2 + length) % length],
        this.items[length - 1],
        ...this.items,
        this.items[0],
        this.items[1 % length],
      ]
    },
    // 読み込みに失敗した画像でも自動送りは止めないため、'error' も確定済みとして扱う
    isActiveImageSettled() {
      const status = this.imageStatus[this.activeIndex]

      return status === 'loaded' || status === 'error'
    },
    // 表示計測と同じく、中央バナーが見えている間だけ自動送りする
    canAutoplay() {
      return (
        this.autoplay &&
        !this.isHovering &&
        this.isInView &&
        this.isPageVisible &&
        this.isActiveImageSettled
      )
    },
    trackStyle() {
      const offset =
        this.trackIndex * (this.sideWidth + this.gap) + this.activeWidth / 2

      return {
        transform: `translateX(${-offset}px)`,
        transition: this.disableTransition
          ? 'none'
          : `transform ${this.transitionDuration}ms ease`,
        // CSSの固定値(16px)を上書きし、位置計算に使うgapと実際の描画間隔を一致させる
        gap: `${this.gap}px`,
      }
    },
  },
  watch: {
    // 自動送りの停止・再開はここに一本化する（条件の追加漏れを防ぐため）
    canAutoplay(canAutoplay) {
      if (canAutoplay) {
        this.startAutoplay()
      } else {
        clearTimeout(this.timer)
      }
    },
    // 中央から外れたバナーの待機を取り消し、新しい中央バナーを最初から数える
    activeIndex(newIndex, oldIndex) {
      this.tracker.setState(oldIndex, { inView: false })
      this.syncActiveToTracker()
    },
    isInView() {
      this.syncActiveToTracker()
    },
    imageStatus: {
      handler() {
        this.syncActiveToTracker()
      },
      deep: true,
    },
    isPageVisible(isPageVisible) {
      this.tracker.setPageVisible(isPageVisible)
    },
  },
  mounted() {
    // observer・trackerはテンプレートで参照しないため、リアクティブにしない
    this.tracker = createViewabilityTracker({
      dwellMs: 1000,
      onViewable: (key) => {
        if (!this.bannerType || !this.$gtag) {
          return
        }

        this.trackImpression(this.items[key], key)
      },
    })

    // 非対応ブラウザでは計測も自動送りも止まらないよう、見えているものとして扱う
    if (typeof IntersectionObserver === 'undefined') {
      this.isInView = true
    } else {
      // thresholdを指定しても交差の有無が変わるたびに呼ばれるため、割合も確認する
      this.observer = new IntersectionObserver(
        (entries) => {
          // 描画が詰まると同じ要素の変化が時系列順にまとめて届くため、最新（末尾）を使う
          const entry = entries[entries.length - 1]

          this.isInView = entry.isIntersecting && entry.intersectionRatio >= 0.5
        },
        { threshold: 0.5 }
      )
      this.observer.observe(this.$refs.viewport)
    }

    document.addEventListener('visibilitychange', this.onVisibilityChange)
    this.onVisibilityChange()

    this.startAutoplay()
  },
  beforeDestroy() {
    clearTimeout(this.timer)
    clearTimeout(this.snapTimer)

    if (this.observer) {
      this.observer.disconnect()
    }

    document.removeEventListener('visibilitychange', this.onVisibilityChange)
    this.tracker.destroy()
  },
  methods: {
    // request_banner.php の imgPath（例: images/banner/202610y_01.png）から
    // 月替わりでも一意になるバナーidを導出する（例: 202610y_01）
    bannerId(item) {
      const filename = item.imgPath.split('/').pop()

      return filename.replace(/\.[^.]+$/, '')
    },
    trackImpression(item, index) {
      this.$gtag.event('request_banner_impression', {
        request_banner_id: this.bannerId(item),
        request_banner_type: this.bannerType,
        request_banner_position: String(index),
        request_banner_version: 'carousel',
        request_banner_impression_value: 1,
      })
    },
    handleActiveClick(item) {
      // openInNewTabが真=外部リンクとして実遷移させるため、ページ内スクロールは発生させない
      if (!item.openInNewTab) {
        this.$emit('item-click', item)
      }

      if (!this.bannerType || !this.$gtag) {
        return
      }

      // 表示とみなす前にクリックされた場合も、見られたものとして表示を先に送る
      this.tracker.countNow(this.activeIndex)

      this.$gtag.event('request_banner_click', {
        request_banner_id: this.bannerId(item),
        request_banner_type: this.bannerType,
        request_banner_position: String(this.activeIndex),
        request_banner_version: 'carousel',
        request_banner_click_value: 1,
      })
    },
    // setIntervalではなく、進むたびに1回だけ次のタイマーを予約する方式にして
    // 手動操作直後に古いタイマーが紛れ込む余地をなくす
    startAutoplay() {
      clearTimeout(this.timer)

      // ホバー中・画面外等ではクリック操作由来のstartAutoplay呼び出しでも再開しない
      if (this.canAutoplay) {
        this.timer = setTimeout(this.next, this.interval)
      }
    },
    // 止める・再開するのは watch の canAutoplay に任せる
    pauseAutoplay() {
      this.isHovering = true
    },
    resumeAutoplayOnLeave() {
      this.isHovering = false
    },
    // extendedItemsのindex（折り返し用の複製を含む）を、itemsのindexに変換する
    realIndex(extendedIndex) {
      const length = this.items.length

      return (extendedIndex - 2 + length) % length
    },
    onImageLoad(extendedIndex) {
      this.imageStatus[this.realIndex(extendedIndex)] = 'loaded'
    },
    onImageError(extendedIndex) {
      const index = this.realIndex(extendedIndex)

      // 同じ画像の複製要素の結果が後から来るため、読み込めた結果を失敗で上書きしない
      if (this.imageStatus[index] !== 'loaded') {
        this.imageStatus[index] = 'error'
      }
    },
    syncActiveToTracker() {
      this.tracker.setState(this.activeIndex, {
        inView: this.isInView,
        imageReady: this.imageStatus[this.activeIndex] === 'loaded',
      })
    },
    onVisibilityChange() {
      this.isPageVisible = document.visibilityState === 'visible'
    },
    prev() {
      const length = this.items.length

      // 既にクローン位置を超えている状態で連打されると、trackIndexが配列範囲外まで
      // 進んで中央が空白になるため、先にアニメーション無しで実位置へ戻してから進める
      if (this.trackIndex <= 1) {
        this.snapInstantly()
      }

      this.activeIndex = (this.activeIndex - 1 + length) % length
      this.trackIndex -= 1

      if (this.trackIndex <= 1) {
        this.snapAfterTransition()
      }

      this.startAutoplay()
    },
    next() {
      const length = this.items.length

      if (this.trackIndex >= length + 2) {
        this.snapInstantly()
      }

      this.activeIndex = (this.activeIndex + 1) % length
      this.trackIndex += 1

      if (this.trackIndex >= length + 2) {
        this.snapAfterTransition()
      }

      this.startAutoplay()
    },
    goTo(index) {
      this.activeIndex = index
      this.trackIndex = index + 2
      this.startAutoplay()
    },
    // クローン位置まで滑ったら、アニメーション終了後に見た目を変えずに実位置へ戻す
    // (transitionendは子要素のサイズ変化ともバッティングするため使わず、
    //  CSSのtransition時間と同じ固定時間だけ待つ)
    snapAfterTransition() {
      clearTimeout(this.snapTimer)

      this.snapTimer = setTimeout(() => {
        this.snapToActiveIndex()
      }, this.transitionDuration)
    },
    // 既にクローン位置を超えた状態でprev/nextが呼ばれた場合に、アニメーション無しで
    // 即座に実位置へ戻す（連打でtrackIndexが配列範囲外に進み続けるのを防ぐ）
    snapInstantly() {
      clearTimeout(this.snapTimer)
      this.snapToActiveIndex()
    },
    snapToActiveIndex() {
      this.disableTransition = true
      // 呼び出し時点のactiveIndexから算出する（連打で古い値を使ってしまわないため）
      this.trackIndex = this.activeIndex + 2

      this.$nextTick(() => {
        const trackEl = this.$refs.track

        // 強制再描画してからtransitionを戻す
        if (trackEl) {
          // eslint-disable-next-line no-unused-expressions
          trackEl.offsetHeight
        }

        this.disableTransition = false
      })
    },
    onSideClick(extendedIndex) {
      const length = this.items.length

      if (extendedIndex < 2) {
        this.prev()
        return
      }
      if (extendedIndex > length + 1) {
        this.next()
        return
      }

      this.goTo(extendedIndex - 2)
    },
    itemStyle(index) {
      const isActive = index === this.trackIndex

      return {
        width: `${isActive ? this.activeWidth : this.sideWidth}px`,
        height: `${isActive ? this.activeHeight : this.sideHeight}px`,
        transition: this.disableTransition
          ? 'none'
          : `width ${this.transitionDuration}ms ease, height ${this.transitionDuration}ms ease`,
      }
    },
  },
}
